import { LogLevel, PublicClientApplication, type AccountInfo, type RedirectRequest } from "@azure/msal-browser"
import { reactive } from "vue"

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/' + import.meta.env.VITE_MSAL_TENANT_ID,
    redirectUri: import.meta.env.BASE_URL,
    postLogoutUri: import.meta.env.BASE_URL + '/auth/login',
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'localStorage'
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Warning
    }
  }
}

export const requestConfig: RedirectRequest = {
  scopes: [
    'openid',
    import.meta.env.VITE_MSAL_API_SCOPE
  ]
}

export const state = reactive({
  isAuthenticated: false,
  roles: [],
  isAdmin: false,
  user: null as AccountInfo | null
})

export const msalInstance = new PublicClientApplication(msalConfig)